import { trackEvent } from "@pb/utils/tracking";
import trackingConstants from './trackingConstants';
const trackingOnView = (trackingPromotionCreative, trackingActivityCode, trackingActivityType) => {
    const finalData = Object.assign(Object.assign({}, trackingConstants.TRACKING_ON_VIEW), { promotion_creative: [trackingPromotionCreative], promotion_id: [trackingActivityCode], promotion_name: [trackingActivityType] });
    trackEvent(finalData);
};
const trackingOnClick = (trackingPromotionCreative, trackingActivityCode, trackingActivityType) => {
    const finalData = Object.assign(Object.assign({}, trackingConstants.TRACKING_ON_CTA_CLICK), { promotion_creative: [trackingPromotionCreative], promotion_id: [trackingActivityCode], promotion_name: [trackingActivityType] });
    trackEvent(finalData);
};
export { trackingOnView, trackingOnClick };
//# sourceMappingURL=tracking.js.map